import popupStyles from "./appoitmentProgramPopup.module.css";
import { IPopupWithoutProps } from "../../../types/types";
import { ITreatmentPlan } from "../../../services/types/user.types";
import { getPrintDate } from "../../../utils/utils";

function AppoitmentProgramPopup({ onClose, treatmentPlan }: IPopupWithoutProps & { treatmentPlan: ITreatmentPlan }) {
    const treatmentSequence = (treatmentPlan.sequenceCount === 1 ? "פעם ב" : treatmentPlan.sequenceCount === 2 ? "פעמיים ב" : `${treatmentPlan.sequenceCount} פעמים ב`) + treatmentPlan.period
    return (
        <article className={popupStyles.popup}>
            <div className={popupStyles.popup__content}>
                {/* <button className={popupStyles.popup__closeBtn} onClick={onClose} /> */}
                <h2 className={popupStyles.popup__title}>תוכנית {treatmentPlan.appointmentsProgram.name}</h2>
                <p className={popupStyles.popup__text}>
                    מועד הקמת תוכנית: {getPrintDate(new Date(treatmentPlan.appointmentsProgram.createDate))}
                </p>
                <p className={popupStyles.popup__text}>
                    שם מטפל: {treatmentPlan.therapistUserName ?? "אין מידע"}
                </p>
                <p className={popupStyles.popup__text}>
                    מספר מפגשים: {treatmentPlan.appointmentsProgram.countOfAppointments}
                </p>
                <p className={popupStyles.popup__text}>
                    תדירות: {(!treatmentPlan.period || !treatmentPlan.sequenceCount) ? "אין מידע" : treatmentSequence}
                </p>
                <p className={popupStyles.popup__text}>
                    אופן הטיפול: {treatmentPlan.mediaName ?? "אין מידע"}
                </p>
                <button
                    className={`button hover ${popupStyles.popup__nextBtn}`}
                    onClick={onClose}
                >
                    אישור וסגירה
                </button>
            </div>
        </article>
    );
}

export default AppoitmentProgramPopup;
